module.exports = __webpack_public_path__ + "img/step12-c.45904c19.png";